import {
  Button,
  Card,
  Grid,
  TextField,
  MenuItem,
  Select,
  Typography,
  Box,
} from '@mui/material';
import { useState } from 'react';

const acTypes: string[] = [
  'Split AC',
  'Vrv/vrf AC',
  'Window AC',
  'Ducted AC',
  'Cassette AC',
  'Tower AC',
  'Concealed AC',
];

const ProblemReportForm: React.FC<{
  existingDetails: {
    problem: string;
    comments: string;
    acType?: string;
  };
  onUpdate: (problem: string, comments: string, acType: string) => void;
  setCurrDirty: React.Dispatch<React.SetStateAction<any>>;
  showSnackbar: (
    message: string,
    severity?: 'success' | 'error' | 'warning' | 'info',
  ) => void;
}> = ({ existingDetails, onUpdate, setCurrDirty, showSnackbar }) => {
  const [problem, setProblem] = useState<string>(existingDetails.problem || '');
  const [comments, setComments] = useState<string>(
    existingDetails.comments || '',
  );
  const [acType, setAcType] = useState<string>(existingDetails.acType || '');

  const handleSave = () => {
    console.log('problem, comments, acType', problem, comments, acType);
    if (acType == '') {
      showSnackbar('Please select an AC type', 'error');
      return;
    }
    if (problem == '') {
      showSnackbar('Please select a problem', 'error');
      return;
    }
    if (comments == '') {
      showSnackbar('Please enter comments', 'error');
      return;
    }
    onUpdate(problem, comments, acType);
    setCurrDirty(null);
  };

  const otherIssues: string[] = [
    'Water leakage',
    'Noise problem',
    'Gas top-up',
    'PCB fault',
    'Remote fault',
    'Fan/Blower fault',
    'Fan motor',
    'Outdoor fan fault',
    'Outdoor fan blade fault',
    'Outdoor fan motor fault',
    'Others',
  ];

  return (
    <Card sx={{ backgroundColor: '#1C1C1C', p: 3, borderRadius: 2 }}>
      <Grid container spacing={2}>
        {/* AC Type Selection */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ color: 'white', mb: 1 }}>
            Select AC Type
          </Typography>
          <Select
            fullWidth
            value={acType}
            onChange={(e) => setAcType(e.target.value)}
            variant="outlined"
            displayEmpty
            sx={{ borderRadius: 1 }}
          >
            <MenuItem value="" disabled>
              Select AC Type
            </MenuItem>
            {acTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        {/* Problem Selection */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ color: 'white', mb: 1 }}>
            Select Problem
          </Typography>
          <Select
            fullWidth
            value={problem}
            onChange={(e) => setProblem(e.target.value)}
            variant="outlined"
            displayEmpty
            sx={{ borderRadius: 1 }}
          >
            <MenuItem value="" disabled>
              Select Problem
            </MenuItem>
            {otherIssues.map((issue) => (
              <MenuItem key={issue} value={issue}>
                {issue}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        {/* Comments TextArea */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ color: 'white', mb: 1 }}>
            Comments
          </Typography>
          <TextField
            multiline
            fullWidth
            rows={3}
            variant="outlined"
            value={comments}
            placeholder="Type here.."
            onChange={(e) => setComments(e.target.value)}
            sx={{ borderRadius: 1 }}
          />
        </Grid>

        {/* Save Button */}
        <Grid item xs={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            sx={{
              mt: 2,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 'bold',
              backgroundColor: '#d32f2f',
            }}
            fullWidth
          >
            Done
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

export { ProblemReportForm };
